export const Constant = {
    "version": "1.0.5",
};